<template>
    <hooper class="home-banner" :settings="settings">
        <slide>
            <div class="card">
                <div class="apn-banner--img">
                    <img src="../assets/images/home-slider-1.jpg" alt="home slider">
                </div>
            </div>
        </slide>
        <slide>
            <div class="card">
                <div class="apn-banner--img">
                    <img src="../assets/images/home-slider-2.jpg" alt="home slider">
                </div>
            </div>
        </slide>
        <pagination slot="hooper-addons"></pagination>
        <navigation slot="hooper-addons"></navigation>
    </hooper>
  
</template>

<script>
// import { VueTyper } from 'vue-typer'
import { Hooper, Slide, Pagination, Navigation } from 'hooper'
import 'hooper/dist/hooper.css'

export default {
    name: 'HomeBanner',
    components: {
        // VueTyper,
        Hooper,
        Slide,
        Pagination,
        Navigation,
    },
    data() {
        return {
            settings: {
                wheelControl: false,
                autoPlay: false,
                playSpeed: 5000,
                transition: 800,
                hoverPause: false,
                infiniteScroll: true,
            }
        }
    },
}
</script>

<style scoped lang="scss">
.home-banner {
    --banner-height: 200px;
    width: 100%;
    height: var(--banner-height);
    max-height: 100vh;
    // margin-top: var(--header-height);
    @media (min-width: 992px) {
        --banner-height: 550px;
    }
    .hooper-slide {
        .card {
            width: 100%;
            height: 100%;
            position: relative;
            .apn-banner--img {
                width: auto;
                height: 100%;
                position: relative;
                background-color: var(--primary);
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;
                img {
                    width: auto;
                    height: 100%;
                }
                &::before,
                &::after {
                    content: '';
                    display: blo;
                }
            }
        }
    }
}
</style>
